import KeyFigureRowTemplate from "./KeyFigureRowTemplate.js";
import PreliminaryResultRow from "../../reports/rows/PreliminaryResultRow.js";

/**
 * Specific subclass of keyFigureRowTemplate to support the behavior of
 * preliminary result rows in the Balance Statement.
 *
 * See the documentation of `preliminaryResultRow.js` for more information
 * about the behavior differences with regular keyFigure rows.
 *
 * @param {string} spec.title - Title of the preliminary result row.
 */
export default class PreliminaryResultRowTemplate extends KeyFigureRowTemplate {
	constructor({ title }) {
		super(...arguments);

		this._title = title;
	}

	_instanceClass() {
		return PreliminaryResultRow;
	}

	_interpretationSpec() {
		const spec = super._interpretationSpec(...arguments);

		spec.title = this._title;

		return spec;
	}

	static isVisible() {
		return false;
	}
}
